import axios from '../Backend';

export const getListOfSignatures = async () => {
    try {
        const res = await axios.get(`/api/v2/signature`);
        const resData = res.data
        return resData.data
    } catch (e) {
        if (e.response?.data) {
            console.log('getListOfSignatures :: Response Error', e.response.data)
        }
        else {
            console.log('getListOfSignatures :: Error', e)
        }
        throw e
    }
}

export const getSignatureDetailsById = async (signatureId) => {
    try {
        const res = await axios.get(`/api/v2/signature/${signatureId}`);
        const resData = res.data
        return resData.data
    } catch (e) {
        if (e.response?.data) {
            console.log('getListOfSignatures :: Response Error', e.response.data)
        }
        else {
            console.log('getListOfSignatures :: Error', e)
        }
        throw e
    }
}

export const sendSignatureDoc = async (signatureId, clientName, msgType, name, prefillData) => {
    try {
        const reqBody = {
            clientName,
            msgType,
            name,
            prefillData
        }
        const res = await axios.post(`/api/v2/signature/${signatureId}/send`, reqBody);
        const resData = res.data
        return resData.data
    } catch (e) {
        if (e.response?.data) {
            console.log('getListOfSignatures :: Response Error', e.response.data)
        }
        else {
            console.log('getListOfSignatures :: Error', e)
        }
        throw e
    }
}